import { ReactComponent as Polkadot } from "../../../components/icons/polkadot.svg";
import { polkadotColor } from "./common";

const gen6dev = {
  name: "Gen6 Dev",
  icon: <Polkadot />,
  identity: "gen6dev",
  sub: "gen6dev",
  value: "gen6dev",
  chain: "gen6dev",
  symbol: "GSX",
  decimals: 18,
  chainIcon: "originalGen6",
  ...polkadotColor,
  buttonColor: "#E6007A",
  logo: "logo-img-2",
  modules: {
    treasury: false,
    governance: false,
    identity: false,
    multisig: false,
    vestings: false,
    proxy: false,
  },
  nodes: [
    { name: "Gen6 explorer", url: "wss://api.explorer.gen6.dev/rpc"},
    // { name: "Gen6 app", url: "wss://gen6.dev/node"},
    // { name: "localhost", url: "ws://127.0.0.1:9944" },
  ],
  useOnChainBlockData: true,
};

export default gen6dev;
